import { PackingSupplierStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class POSupplierStatus{
    @ApiProperty()
    purchaseOrderId:number;
    @ApiProperty()
    supplierStatus:PackingSupplierStatusEnum
}